<template>
  <div>
    <a
      v-if="companyId && !isExporting"
      href="#"
      title=""
      class="action-bar__link"
      @click.prevent="exportCostCenters"
    >{{ $t(`${namespace}.export`) }}</a>

    <a
      v-else-if="isExporting"
      href="#"
      class="action-bar__link"
      slot="activator"
      @click.prevent
    >
      {{ $t('Common.exporting') }}
    </a>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { exportAsync } from 'utils/exportAsync'

export default {
  name: 'ExportCostCentersAction',
  props: {
    search: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState({
      company: state => state.company.selectedCompany
    }),

    companyId () {
      if (this.$route.name === 'CompanyDetail') {
        return this.$route.params.id
      }

      return this.company ? this.company.id : null
    }
  },
  data () {
    return {
      namespace: 'Views.CostCenterPage',
      isExporting: false,
      downState: {
        downloadCsvAutoRequest: undefined,
        downloadCsvPercentage: 0
      }
    }
  },
  methods: {
    ...mapActions({
      successAlert: 'snackbarAlert/success',
      errorAlert: 'snackbarAlert/error',
      showAlert: 'snackbar/show'
    }),

    onExportAsyncSuccess () {
      this.successAlert(this.$t(`${this.namespace}.successExport`))
      this.isExporting = false
    },

    onExportAsyncError () {
      this.showAlert({
        type: 'error',
        message: this.$t('Common.errorExport')
      })
      this.isExporting = false
    },

    async exportCostCenters () {
      this.isExporting = true

      try {
        exportAsync(
          { companyId: this.companyId, search: this.search, type: 'configCostCenter' },
          '99Empresas_centrosDeCusto.csv',
          this.onExportAsyncSuccess,
          this.onExportAsyncError,
          this.downState
        )
      } catch (err) {
        this.isExporting = true
        console.log('Error trying to export', err)
      }
    }
  },
  destroyed () {
    // clearInterval(this.downState.downloadCsvAutoRequest)
  }
}
</script>
